import { Box, Typography } from '@mui/material';
import { LoadingIcon } from '@pn/ui/icons/LoadingIcon';
import React from 'react';

function getLoadingText() {
  const possibleMessages = [
    'Initializing',
    'Downloading',
    'Loading',
    'Getting the good stuff',
    'Loading secret sauce',
    'Waking up the hamsters',
    'Getting the numbers and the letters',
    'Summoning the unicorns',
    'Rounding up the pixels',
    'Brewing the magic potion',
    'Teaching zeros to befriend ones',
    'Cranking the internet handle',
    'Feeding the code gremlins',
    'Calibrating the flux capacitor',
    'Sprinkling some tech glitter',
    'Warming up the electrons',
    'Consulting with the matrix',
    'Giving it some digital elbow grease',
    'Rolling out the digital red carpet',
    'Baking some digital cookies',
    'Tickling the bytes',
    'Beaming up the data',
    'Polishing the pixels',
    'Fishing in the data stream',
    'Training the ninja code',
    'Gathering some digital stardust',
  ];
  const randomIndex = Math.floor(Math.random() * possibleMessages.length);
  return possibleMessages[randomIndex];
}

export function LoadingMessage() {
  const loadingText = React.useMemo(() => getLoadingText(), []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}>
      <LoadingIcon color={'secondary'} fontSize={'large'} />
      <Typography
        variant="subtitle1"
        sx={[{
          textAlign: "center",
          mt: 2
        }, (theme) => ({
          color: theme.palette.text.disabled,
        })]}>
        {loadingText} ...
      </Typography>
    </Box>
  );
}
